import { useMemo } from "react";

import Grid from "@mui/material/Grid";

import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { Button, LoadingOrValue } from "@covertree/ui";
import { Tooltip } from "@covertree/ui/content";

import { PolicyStatus } from "@covertree/agent-portal-graphql";
import { useSendEsignReminder } from "@hooks/actions/useSendEsignReminder";

import { mapTermsAcceptance } from "../utils/mapTermsAcceptance";
import { PolicyDetailsContentProps } from "../../../types";

export function TermsAcceptance({
  policy,
  loading,
}: PolicyDetailsContentProps) {
  const isStatusPendingEsignRequired = useMemo(
    () =>
      [
        PolicyStatus.PendingEsignRequired,
        PolicyStatus.PendingCancellationEsignRequired,
      ].includes(policy?.status),
    [policy]
  );

  const noEsignRequest = useMemo(
    () => policy?.isAgentsSignResponsibility || policy?.physicallyMailDocuments,
    [policy?.isAgentsSignResponsibility, policy?.physicallyMailDocuments]
  );

  const { sendEsignReminder, loading: isSendEsignReminderLoading } =
    useSendEsignReminder();

  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Terms acceptance",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={mapTermsAcceptance(
                  policy?.isEsigned,
                  policy?.isAgentsSignResponsibility
                )}
                height={24}
                width={250}
              />
            ),
            showAsTypography: true,
            gridSize: 12,
            inlineButton: isStatusPendingEsignRequired ? (
              !noEsignRequest ? (
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => sendEsignReminder(policy.policyLocator)}
                  disabled={isSendEsignReminderLoading}
                  loading={isSendEsignReminderLoading}>
                  Resend email
                </Button>
              ) : (
                <Tooltip
                  dataTestId="tooltip"
                  tooltip="This policy needs to be signed manually due to no paperless discount applied."
                  size="large"
                  sx={{ mr: 3 }}
                />
              )
            ) : undefined,
          },
          {
            label: "Description",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={policy?.description || "None"}
                height={24}
                width={250}
              />
            ),
            showAsTypography: true,
            gridSize: 12,
          },
        ]}
      />
    </Grid>
  );
}
